import useMediaQueries from "hooks/useMediaQueries";
import React, { useEffect, useState } from "react";

interface IUseContactCircleModalPosition {
  modalWindowRef: React.RefObject<HTMLDivElement>;
  targetRef: HTMLDivElement;
}

interface ICords {
  left?: number;
  top?: number;
}

const useContactCircleModalPosition = ({
  modalWindowRef,
  targetRef,
}: IUseContactCircleModalPosition) => {
  const [cords, setCords] = useState<ICords>({});

  const { mobileCondition } = useMediaQueries();

  const contactElemPos = targetRef?.getBoundingClientRect();
  // realContactHeight reduced by 40px because of the padding
  const realContactHeight = contactElemPos?.height - 40;

  const arrowStyle =
    contactElemPos && cords
      ? mobileCondition
        ? {
            left:
              contactElemPos.left -
              (cords.left || 0) +
              contactElemPos.width / 2 -
              10,
          }
        : {
            // top position of arrow in the middle of the targetRef relative to the modal window
            top:
              contactElemPos.top -
              (cords.top || 0) +
              realContactHeight / 2 -
              15,
          }
      : {};

  const handlePosition = () => {
    // get size of the modal window
    const windowCoords = modalWindowRef.current?.getBoundingClientRect();
    if (!windowCoords) return;
    const height = windowCoords.height;
    const width = windowCoords.width;
    if (modalWindowRef.current && contactElemPos && cords?.left === undefined) {
      if (mobileCondition) {
        const left = 20;
        const top = contactElemPos.top - height - 10;
        setCords({ left, top });
      } else {
        // const left = isManageContacts
        //   ? contactElemPos.right + 10
        //   : contactElemPos.left - width - 10;
        const left = contactElemPos.left - width - 10;
        const top =
          contactElemPos.top + realContactHeight / 2 - height / 3 - 60;
        setCords({ left, top });
      }
    }
  };

  useEffect(() => {
    setTimeout(() => {
      handlePosition();
    }, 700);
  }, []);

  return { cords, arrowStyle };
};

export default useContactCircleModalPosition;
